<form [ngrxFormState]="form" *ngIf="form$ | async; let form" class="w-100" autocomplete="off" role="presentation">

  <div class="content">
    <h3 class="col-12 p-0">Tell us a little more about yourself</h3>
    <div class="row">
      <div class="col col-md-12 p-0">
        <app-entry class="entry-dark-bg" title="First name" [control]="form.controls.firstName" (onInputBlur)="
                                    onInputValueChanged(
                                      form.controls.firstName,
                                      form.value
                                    )
                                  ">
        </app-entry>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12 p-0">
        <app-entry class="entry-dark-bg" title="Last name" [control]="form.controls.lastName" (onInputBlur)="
                                    onInputValueChanged(
                                      form.controls.lastName,
                                      form.value
                                    )
                                  ">
        </app-entry>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12 p-0">
        <app-entry-date class="entry-dark-bg" title="Date of birth" [date]="form.controls.dob" [maxdate]="today"
          (onValueChange)="
                                    onInputValueChanged(
                                      form.controls.dob,
                                      form.value
                                    )
                                  ">
        </app-entry-date>
      </div>
    </div>
    <div class="col col-md-12 d-flex flex-row flex-wrap p-0">
      <div class="col-12 col-md-6 dob mobile-field">
        <app-entry class="entry-dark-bg" title="Mobile" [control]="form.controls.mobile" (onInputBlur)="
                                    onInputValueChanged(
                                      form.controls.mobile,
                                      form.value
                                    )
                                  ">
        </app-entry>
      </div>
      <div class="col-12 col-md-6 gender p-0">
        <app-entry-dropdown class="entry-dark-bg" title="Gender" list="gender" (onValueChange)="
                                    onInputValueChanged(
                                      form.controls.gender,
                                      form.value
                                    )
                                  " [control]="form.controls.gender">
        </app-entry-dropdown>
      </div>
    </div>

    <div class="row">
      <div class="col col-md-12 p-0">
        <app-entry-address-accurity class="entry-dark-bg" title="Address" country="AU" [address]="form.controls.address"
          [isSearchMode]="!form.value.address.fullAddress"
          [allowOverseasAddress]="false" (onValueChange)="
                                    onInputValueChanged(
                                      form.controls.address,
                                      form.value
                                    )
                                  ">
        </app-entry-address-accurity>
      </div>
    </div>
  </div>
  <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 col-12 p-0">
    <app-button class="back-btn" title="Back" [isDisabled]="(isLoading$ | async)" color="light" icon="west"
      (onClick)="onMoveBackClick()">
    </app-button>

    <app-button class="custom" title="Next"
      [isDisabled]="(isLoading$ | async) || form.isInvalid || (hasError$ | async) || (localBlock$ | async)" icon="east"
      loading (onClick)="onMoveNextClick(form)">
    </app-button>
  </div>
  <div class="footer footer-mobile col-12 mt-5 p-0">
    <ng-template [ngTemplateOutlet]="FooterStep1"></ng-template>
  </div>
</form>

<ng-template #FooterStep1>
  <h5>
    Need help?
    <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
  </h5>
  <p>
    All information is of a general nature only. It is important to do your own
    research and consider things like fees, investment performance, insurance,
    risk, and alignment with your values when considering if Verve Super is
    right for you. Consider seeking financial advice. When considering
    performance, past performance is not indicative of future performance.
    <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
  </p>
</ng-template>